import { capitalCase } from "change-case";

export default function UserStatusCell({ value }: { value: string }) {
  return <span>{capitalCase(value)}</span>;
}
